import {
  queryAddEditApiCallSend,
  queryAddNewApiCallSend,
  queryDeleteItem,
  queryEditItemApiCallSend,
  queryList,
} from './service';

import { toPaginate } from '@/utils/infrastructure';
import _ from 'lodash';

const meta = {
  page: 1,
  limit: 5,
  count: 0,
  totalPages: 0,
};

const Model = {
  namespace: 'apiCallSend',
  state: {
    newApiCallSend: false,
    selectedItem: null,
    formConfig: null,
    list: [],
    pagination: meta,
    select:
      'id,valueSource,fixedValue,formula,internalField,parameterCodification,tableParameterName,parameterName',
    notSelectSearch: 'parameterCodification,valueSource,fixedValue,formula,internalField',
    expand: {
      form: { select: 'name' },
      field: { select: 'displayText' },
      variable: { select: 'internalName' },
    },
    paramsView: {
      select:
        'id,valueSource,fixedValue,formula,internalField,parameterCodification,tableParameterName,parameterName,formFieldValueSource,sendParameterPosition',
      expand: {
        form: { select: 'name' },
        field: { select: 'displayText' },
        variable: { select: 'internalName' },
      },
    },
    view: false,
    orderBy: '',
    id: null,
    loadingItem: false,
  },

  effects: {
    *fetchList({ payload }, { call, put }) {
      try {
        const response = yield call(queryList, payload);
        yield put({
          type: 'queryApiCallSends',
          payload: {
            ...response,
            limit: payload.limit,
            page: payload.page,
          },
        });
      } catch (error) {
        /*  */
      }
    },

    *addNewApiCallSend({ payload }, { put }) {
      yield put({
        type: 'addApiCallSend',
        payload,
      });
      if (!_.isNil(payload.id)) {
        yield put({
          type: 'editOrViewApiCallSend',
          payload,
        });
      }
    },

    *editItemApiCallSend({ payload }, { call, put }) {
      try {
        const table = yield call(queryEditItemApiCallSend, payload);
        yield put({
          type: 'editApiCallSend',
          payload: {
            ...payload,
            state: true,
            item: table,
          },
        });
      } catch (error) {
        /* */
      }
    },

    *saveNewApiCallSend({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddNewApiCallSend, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallSend',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          if (error.validationErrors && _.isEmpty(error.validationErrors[0].field)) {
            _.set(error, 'message', error.validationErrors[0].errorMessages[0]);
          }
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *saveEditApiCallSend({ payload }, { call, put }) {
      try {
        const response = yield call(queryAddEditApiCallSend, payload.data);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallSend',
          payload: response,
        });
        yield put({
          type: 'fetchList',
          payload: payload.params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: 'global/showNotificationsForm',
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
            },
            validationErrors: error.validationErrors,
          });
        }
      }
    },

    *deleteItem({ id, params, view }, { call, put }) {
      try {
        yield put({
          type: `global/modalConfirm`,
          state: false,
          id: null,
        });
        yield call(queryDeleteItem, id);
        yield put({
          type: 'global/showNotificationsGlobal',
          payload: {
            visible: true,
            type: 'success',
          },
        });
        yield put({
          type: 'saveApiCallSend',
          payload: {
            state: false,
            item: null,
            view: false,
          },
        });
        yield put({
          type: 'fetchList',
          payload: params,
        });
      } catch (error) {
        if (error && error.message) {
          yield put({
            type: `global/modalConfirm`,
            state: false,
            id: null,
          });
          yield put({
            type: `global/showNotifications${view ? 'Form' : 'Global'}`,
            payload: {
              visible: true,
              type: 'error',
              message: error.message,
              autoHide: view,
            },
          });
        }
      }
    },

    *showItemApiCallSend({ view }, { put }) {
      yield put({
        type: 'showEditItemApiCallSend',
        view,
      });
    },

    *setOrderBy({ payload }, { put }) {
      yield put({
        type: 'orderBy',
        payload,
      });
    },

    *hideAllForms({ payload = 'hideForms' }, { put }) {
      yield put({ type: payload });
    },
  },

  reducers: {
    queryApiCallSends(state, { payload }) {
      return {
        ...state,
        list: payload.items,
        pagination: _.merge(state.pagination, toPaginate(payload)),
      };
    },

    addApiCallSend(state, { payload }) {
      return {
        ...state,
        newApiCallSend: payload.state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
      };
    },

    editOrViewApiCallSend(state) {
      return {
        ...state,
        selectedItem: {},
      };
    },

    editApiCallSend(state, { payload }) {
      return {
        ...state,
        selectedItem: payload.item,
        view: payload.view,
        id: payload.id,
        newUserOnGroup: false,
      };
    },

    saveApiCallSend(state, { payload }) {
      return {
        ...state,
        saveApiCallSend: payload,
        newApiCallSend: false,
        selectedItem: false,
      };
    },

    showEditItemApiCallSend(state, { view }) {
      return {
        ...state,
        view,
      };
    },

    orderBy(state, { payload }) {
      return {
        ...state,
        orderBy: payload,
      };
    },

    hideForms(state) {
      return {
        ...state,
        newApiCallSend: false,
        selectedItem: null,
        view: null,
        orderBy: '',
        id: null,
      };
    },
  },
};

export default Model;
